// extracted by mini-css-extract-plugin
export default {"formBox":"ResetPassword_formBox__lQTul","formContainer":"ResetPassword_formContainer__6dNY9"};